import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface FeatureAnnouncement {
  id: string;
  title: string;
  description: string;
  icon: string;
  badge_text: string;
  display_order: number;
}

export interface GetActiveResponse {
  show_modal: boolean;
  features: FeatureAnnouncement[];
}

@Injectable({ providedIn: 'root' })
export class FeatureAnnouncementService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.api.gatewaySecured;

  getActive(parentclubId: string): Observable<GetActiveResponse> {
    return this.http.post<GetActiveResponse>(`${this.base}/feature-announcement/get-active`, { parentclub_id: parentclubId });
  }

  markShown(parentclubId: string, featureIds: string[]): Observable<any> {
    return this.http.post(`${this.base}/feature-announcement/mark-shown`, { parentclub_id: parentclubId, feature_ids: featureIds });
  }

  suppress(parentclubId: string): Observable<any> {
    return this.http.post(`${this.base}/feature-announcement/suppress`, { parentclub_id: parentclubId });
  }
}
